import { Box, styled } from "@mui/material";

export const PrivacyTermsWrapper = styled(Box)`
  display: flex;
  max-width: 1200px;
  margin: 10px auto 50px auto;
  flex-flow: column;
`;
